
import CardCrausalView from "../../components/CardCrausalView";
import CardSwapSectionComponent from "../../components/CardsSwapSection";
import SliderViewSection from "../../components/SliderViewSection";
import { AllProductGif, CardSwapImg,  
  Netzero1,
  Netzero2,
  Netzero3,
  Netzero4,
  Netzero5, } from "../../constant";
import PlanCards from "../../components/PlanCardSection";
import TestimonialSlider from "../../components/FeedbackSlider";
import ContactUs from "../../components/ContactUs";
import StayInLoop from "../../components/StayInLoop";
import FourCardsSwap from "../../components/FourCardSwapSection";
import ProductLanding from "../../components/Products/ProductLanding";


const safetyAndSustainabilityData = [
  {
    title: "NetZero. Intelligent EHS & ESG Operations.",
    subtitle:
      "Digitize safety, sustainability and compliance workflows through a unified enterprise platform delivering real-time visibility, proactive risk management and AI-driven insights.",
    lists: [
      "Unified EHS & ESG Platform ",
      "Real-Time Compliance Monitoring",
      "Enterprise Risk Intelligence",
    ],
    mediaUrl: Netzero1
  },
  {
    title: "NetZero. Accelerate Your Net-Zero Journey.",
    subtitle:
      "Track Scope 1, 2 & 3 emissions, energy consumption, decarbonization targets and sustainability initiatives through centralized analytics and automated reporting.",
    lists: [
      "Carbon Accounting & ESG Metrics",
      "Energy & Emissions Dashboards",
      "BRSR, GRI & TCFD and other Frameworks Reporting",
    ],
    mediaUrl: Netzero2
  },
  {
    title: "NetZero. Safer Operations Through Connected Intelligence.",
    subtitle:
      "Improve workforce safety, incident management and operational compliance with intelligent workflows, predictive analytics and digital safety governance.",
    lists: [
      "Incident & Audit Management",
      "Permit to Work & Safety Observations",
      "25+ modules focused on Safety",
    ],
    mediaUrl: Netzero3
  },
  {
    title: "NetZero. Simplifying Enterprise Compliance",
    subtitle:
      "Streamline regulatory reporting, audits and governance processes through automated workflows, centralized documentation and actionable compliance insights.",
    lists: [
      "Regulatory & ESG Compliance",
      "Automated Workflows & Alerts",
      "Governance & Policy Tracking",
    ],
    mediaUrl: Netzero4
  },
  {
    title: "NetZero. Transform Data Into Sustainability Insights",
    subtitle:
      "Leverage AI, analytics and connected enterprise data to enable smarter sustainability decisions, operational resilience and measurable ESG outcomes.",
    lists: [
      "AI-Driven ESG Analytics",
      "Enterprise Sustainability Dashboards",
      "Actionable Operational Intelligence",
    ],
    mediaUrl: Netzero5
  },
];




const AuroraSRPPlans = [
  {
    title: "Starter",
    subtitle: "Ideal for growing organizations beginning their EHS & ESG transformation journey.",
    features: [
      "Incident Management",
      "Audit & Inspection Management",
      "Any 4 Modules",
      "Workflow Automation",
      "Standard Reporting Dashboards"
    ],
  },
  {
    title: "Enterprise",
    subtitle: "Designed for enterprises seeking integrated EHS, ESG and sustainability management.",
    features: [
      "All Core EHS & ESG Modules",
      "Advanced Analytics & Dashboards",
      "Carbon & Emissions Tracking",
      "Workflow & Compliance Automation",
      "Mobile & Multi-Site Access"
    ],
    popular: true,
  },
  {
    title: "Intelligent Enterprise",
    subtitle: "Built for large-scale enterprises requiring AI-driven sustainability and operational intelligence.",
    features: [
      "Everything in Enterprise",
      "AI-Powered Predictive Insights",
      "Sustainability Performance Intelligence",
      "Enterprise API & ERP Integration",
      "Real-Time Operational Monitoring",
      "Executive Command Center Dashboards"
    ],
    recommended: true,
  },
];


const testimonialsData = [
  {
    quote:
      "NetZero enabled us to streamline ESG reporting and improve sustainability visibility across operations.",
    author: "General Manager, EHS",
    note: "An Integrated Energy Enterprise",
  },
  {
    quote:
      "The platform transformed our EHS processes with real-time monitoring, analytics, and actionable insights.",
    author: "Project Safety Head",
    note: "Major Oil & Gas Operator",
  },
  {
    quote:
      "Aurora helped us connect critical industrial assets and improve operational efficiency significantly.",
    author: "Project Manager",
    note: "An Integrated Oil & Gas Operator",
  },
  {
    quote:
      "We now manage compliance, audits, and sustainability reporting from a single intelligent platform.",
    author: "Head, Digital Transformation",
    note: "A Large Mining Company",
  },
  {
    quote:
      "Implementation was seamless, and the solution scaled perfectly across our enterprise operations.",
    author: "Chief Manager – Projects",
    note: "A Large Refining Company",
  },
  {
    quote:
      "The risk engagement simplified complex reporting requirements while improving data accuracy and governance.",
    author: "Chief Risk Officer",
    note: "A Large Power Generation Company",
  },
  {
    quote:
      "Connected operational intelligence and sustainability insights helped us achieve measurable business outcomes.",
    author: "Head – Projects",
    note: "One of the Largest EPC Players",
  },
  {
    quote:
      "Real-time visibility into risks, emissions, and compliance improved our overall operational performance.",
    author: "Head – Sustainability",
    note: "A Large Defence Manufacturer",
  },
  {
    quote:
      "A modern digital transformation platform that delivers measurable impact across EHS, ESG, and operations.",
    author: "Nodal Officer, Digital Initiatives",
    note: "One of the Largest Mining Operators",
  },
];

const cardData = [
  { 
    title: "Unified EHS & ESG Ecosystem",
    description:"Manage safety, sustainability, carbon accounting, audits, permits, incidents and regulatory reporting through a single integrated platform."  },
  {
    title: "Real-Time Sustainability Intelligence",
    description:"Gain proactive visibility into incidents, emissions, audits, compliance gaps and operational risks through live dashboards and analytics."  },
  
  {
    title: "Modern User Experience",
    description:
      "Clean, intuitive and role-based experiences that simplify EHS operations, ESG reporting and cross-functional collaboration.",
  },
];

const FourCardsSwapcardData = [
  {
    title: "Actionable Intelligence",
    description:
      "Convert enterprise EHS & ESG data into meaningful insights that improve compliance, reduce risks and accelerate decision-making.",
  },
  {
    title: "Access Anywhere",
    description:
      "Enable seamless collaboration across sites, teams and leadership through secure access from web, mobile and connected devices.",
  },
  {
    title: "Enterprise-Grade Platform",
    description:
      "Built for scalability, security and operational resilience with modular capabilities tailored to evolving business requirements.",
  },
  {
    title: "Advanced Digital Technologies",
    description:
      "Leverage AI, IoT and analytics to automate workflows, monitor operational performance and enable predictive sustainability management.",
  },
];


export default function ProductNetzero() {
  return (
    <>
      <ProductLanding
        title={`Reach new levels of ESG Excellence`}
        subTitle={`Transform EHS operations, ESG reporting and carbon intelligence through connected workflows, AI-driven insights and enterprise-wide visibility.`}
        isNetzero={false}
        url={AllProductGif}
      />

      <SliderViewSection
        title={"NetZero. Unified EHS & ESG Management Platform."}
        subTitle={"Transform safety, sustainability and compliance operations through connected workflows, predictive insights, emissions management and intelligent enterprise reporting."}
        data={safetyAndSustainabilityData}
      />
      <CardCrausalView
        title={`Why NetZero?`}
        subTitle={"NetZero is an intelligent EHS & ESG platform built to help enterprises transform safety, sustainability, compliance and operational risk management through connected workflows, real-time visibility and AI-driven insights."}
        cardData={cardData}
      />
      {/* <CardSwapSectionComponent data={safetyAndSustainabilityData} /> */}
      <FourCardsSwap
        title={"Innovative EHS & ESG Software. Drive Safer, Smarter Operations."}
        subTitle={"Transform safety, sustainability and compliance management through real-time intelligence, connected workflows and AI-driven operational insights."}
        cardData={FourCardsSwapcardData}
      />
      <TestimonialSlider testimonials={testimonialsData} />
      <PlanCards productName = {"Netzero"} title={"NetZero Deployment Plans"} plans={AuroraSRPPlans} />
      <ContactUs />
      <StayInLoop />
    </>
  );
}
